import { c as _c } from "react/compiler-runtime";
import { BreadcrumbsData, PrimaryButton } from '@systemeio/ui';
import { SaveIcon } from '@systemeio/ui/icons';
import SettingsMenuSkeleton from 'modules/profile/components/settings-menu-skeleton';
import { useSettingsMenuItems } from 'modules/profile/hooks/use-settings-menu-items';
import React, { useMemo, type JSX } from 'react';
import BreadcrumbsDashboard from 'shared/components/breadcrumbs';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { twMerge } from 'tailwind-merge';
interface SettingsLayoutProps {
  isFetching?: boolean;
  onSave?: () => void;
  disabled?: boolean;
  needSave?: boolean;
  customHeader?: JSX.Element;
  titles: BreadcrumbsData[];
  hideSettingsMenu?: boolean;
}
const SettingsLayout = t0 => {
  const $ = _c(33);
  const {
    children,
    isFetching,
    onSave,
    disabled,
    needSave: t1,
    customHeader,
    titles,
    hideSettingsMenu
  } = t0;
  const needSave = t1 === undefined ? true : t1;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    isLoading
  } = useUser();
  let t2;
  if ($[0] !== t) {
    t2 = t("global.settings");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = [{
      isStatic: true,
      caption: t2
    }];
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = t3 as BreadcrumbsData[];
  let t5;
  if ($[4] !== t4 || $[5] !== titles) {
    t5 = t4.concat(titles);
    $[4] = t4;
    $[5] = titles;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const breadCrumbsData = t5;
  const {
    menuItems,
    isReady
  } = useSettingsMenuItems();
  let t6;
  if ($[7] !== breadCrumbsData) {
    t6 = <BreadcrumbsDashboard data={breadCrumbsData} />;
    $[7] = breadCrumbsData;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== disabled || $[10] !== isFetching || $[11] !== needSave || $[12] !== onSave || $[13] !== t || $[14] !== user) {
    t7 = needSave && <PrimaryButton isFetching={isFetching} disabled={!user || disabled} onClick={onSave} className="flex items-center justify-between"><SaveIcon /><span className="hidden sm:flex"> {t("global.save")}</span></PrimaryButton>;
    $[9] = disabled;
    $[10] = isFetching;
    $[11] = needSave;
    $[12] = onSave;
    $[13] = t;
    $[14] = user;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== customHeader || $[17] !== t7) {
    t8 = <div className="flex gap-3">{customHeader}{t7}</div>;
    $[16] = customHeader;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t6 || $[20] !== t8) {
    t9 = <div className="mb-5 flex justify-between">{t6}{t8}</div>;
    $[19] = t6;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== hideSettingsMenu || $[23] !== isLoading || $[24] !== isReady || $[25] !== menuItems) {
    t10 = !hideSettingsMenu && <div className="relative w-full lg:min-h-[506px] lg:w-[250px] ">{isLoading || !isReady ? <SettingsMenuSkeleton /> : <ul className="bg-background-secondary inset-0 flex h-fit max-h-[320px] w-full flex-col overflow-auto rounded-md text-base last:border-b-transparent lg:h-max lg:max-h-full lg:w-[250px]">{menuItems.filter(_temp).map(_temp2)}</ul>}</div>;
    $[22] = hideSettingsMenu;
    $[23] = isLoading;
    $[24] = isReady;
    $[25] = menuItems;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== children || $[28] !== t10) {
    t11 = <div className="mb-9 flex flex-col gap-3 lg:flex-row lg:gap-10">{t10}{children}</div>;
    $[27] = children;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t9) {
    t12 = <>{t9}{t11}</>;
    $[30] = t11;
    $[31] = t9;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};
export default SettingsLayout;
function _temp(setting) {
  return setting.shouldRender;
}
function _temp2(setting_0) {
  return <li key={setting_0.name} className="text-[14px]"><LinkWithoutPrefetch className={twMerge("main-transition-colors border-b-text-secondary/10 hover:bg-brand-primary-subtle focus-visible:border-b-brand-primary focus-visible:bg-brand-primary-subtle relative flex border-b px-5 py-2.5 focus:outline-hidden", setting_0.isActive(setting_0.href) && "bg-brand-primary-subtle text-brand-primary before:bg-brand-primary font-bold before:absolute before:left-0 before:top-0 before:h-full before:w-1 before:rounded-r-[3px]")} href={setting_0.href} data-test-id={setting_0.dataTestId}>{setting_0.name}</LinkWithoutPrefetch></li>;
}